import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { startCase } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { numberToIntegerOrDecimal } from '~utils/utilFunctions';

import { EquipmentData } from '../types';
import { VendorTicketsTableColumn } from '../vendor-tickets-table-columns';

interface EquipmentRowProps {
  equipment: EquipmentData;
  unitOfMeasure: string;
  columns: VendorTicketsTableColumn[];
}

const EquipmentRow = ({ equipment, unitOfMeasure, columns }: EquipmentRowProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.semantic.surfaceSunken,
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'grid',
        gridAutoRows: '40px',
        gridColumn: `span ${columns.length}`,
        gridTemplateColumns: columns.map((column) => column.size).join(' '),
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          ...columns[0].sx,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pl: 6,
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: equipment.isMatched
              ? theme.palette.success.main
              : theme.palette.error.main,
          }}
        />
        <Typography
          sx={{
            fontSize: '12px',
            color: theme.palette.text.primary,
            overflow: 'visible',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            lineHeight: 1.2,
          }}
        >
          {equipment.name}
        </Typography>
      </Box>
      <Box sx={{ ...columns[1].sx, display: 'flex', alignItems: 'center' }}>
        <OverflowAwareText>{equipment.tickets}</OverflowAwareText>
      </Box>
      <Box sx={{ ...columns[2].sx, display: 'flex', alignItems: 'center' }}>
        <OverflowAwareText>
          {numberToIntegerOrDecimal(equipment.totalQuantity)} {startCase(unitOfMeasure)}
        </OverflowAwareText>
      </Box>
      <Box sx={{ ...columns[3].sx }} />
    </Box>
  );
};

export default EquipmentRow;
